export class CancelOrderDto {
    id: number;
    canceledMessage: string;
  }
